import { title } from "process";
import config from "./config";

(function($) {
    $(window).on("load",function () {
        const isResultChartPage = $('.result-chart--dashboard, .result-chart--summary').length > 0;
        const {Chart, radarChartConfig, barChartConfig} = config;

        const renderRadarChart = (data) => {
            const ctx_radar = $("#ctx_radarChart_summary");

            if (ctx_radar.length > 0) {
                new Chart(ctx_radar, {
                    ...radarChartConfig,
                    data: {
                        labels: ["Pillar 1 - Institutional Requirements", "Pillar 2 - Inputs", "Pillar 3 - Processes", "Pillar 4 - Outputs", [["Pillar 5 - Quality and"], ["Optimization"]]],
                        datasets: [
                            {
                                label: "Maturity Level",
                                data: [
                                    data.pillar_1?.maturity_level || 0,
                                    data.pillar_2?.maturity_level || 0,
                                    data.pillar_3?.maturity_level || 0,
                                    data.pillar_4?.maturity_level || 0,
                                    data.pillar_5?.maturity_level || 0,
                                ],
                                borderColor: "rgba(0, 239, 193, 1)",
                                fill: false,
                            },
                            {
                                label: "Reference Level",
                                data: [
                                    data.general_information?.reference_maturity_level || 0,
                                    data.general_information?.reference_maturity_level || 0,
                                    data.general_information?.reference_maturity_level || 0,
                                    data.general_information?.reference_maturity_level || 0,
                                    data.general_information?.reference_maturity_level || 0,
                                ],
                                borderColor: "rgba(9, 110, 124, 1)",
                                fill: false,
                            },
                        ],
                    },
                    options: {
                        plugins: {
                            tooltip: {
                                enabled: false, // deaktiviert Tooltip
                            },
                        },
                    },
                });
            }
        }

        const renderBarCharts = (data) => {
            const chartOptions = {
                scales: {
                    y: {
                        beginAtZero: true,
                        max: data.maxY,
                    }
                },
                plugins: {
                    legend: {
                        display: false, // Legend sichtbar oder nicht
                    },
                }
            };
            
            const pillarData = [
                data.pillar_1 || false,
                data.pillar_2 || false,
                data.pillar_3 || false,
                data.pillar_4 || false,
                data.pillar_5 || false,
            ];
            
            pillarData.forEach((item, index) => {
                const levelChart = $(`#ctx_barChart_pillar_${index + 1}_level`);
                const prioChart = $(`#ctx_barChart_pillar_${index + 1}_prio`);
                const maturityChart = $(`#ctx_barChart_pillar_${index + 1}_maturity`);

                const fillData = (priority, type) => {
                    // return placeholder data
                    if (!item) return [0, 0, 0, 0, 0];

                    return Object.entries(item[type]).map(([key, value]) => {
                        return value[priority] || 0;
                    })
                }

                if (levelChart.length > 0) {
                    new Chart(levelChart, {
                        ...barChartConfig('Challenges frequency classified by Maturity level'),
                        data: {
                            labels: ["Level 1", "Level 2", "Level 3", "Level 4", "Level 5"],
                            datasets: [
                                { label: data.priorities['21'], data: fillData('21', 'level_results'), backgroundColor: "rgba(201, 210, 209, 1)" },
                                { label: data.priorities['22'], data: fillData('22', 'level_results'), backgroundColor: "rgba(9, 110, 124, 1)" },
                                { label: data.priorities['23'], data: fillData('23', 'level_results'), backgroundColor: "rgba(174, 15, 15, 1)" },
                                { label: data.priorities['24'], data: fillData('24', 'level_results'), backgroundColor: "rgba(107, 107, 107, 1)" },
                                { label: data.priorities['25'], data: fillData('25', 'level_results'), backgroundColor: "rgba(0, 239, 193, 1)" },
                            ],
                        },
                        options: chartOptions
                    });
                }   

                if (prioChart.length > 0) {
                    new Chart(prioChart, {
                        ...barChartConfig('Challenges frequency classified by Priorities'),
                        data: {
                            labels: ["Priority 1", "Priority 2", "Priority 3"],
                            datasets: [
                                { label: data.priorities['21'], data: fillData('21', 'prio_results'), backgroundColor: "rgba(201, 210, 209, 1)" },
                                { label: data.priorities['22'], data: fillData('22', 'prio_results'), backgroundColor: "rgba(9, 110, 124, 1)" },
                                { label: data.priorities['23'], data: fillData('23', 'prio_results'), backgroundColor: "rgba(174, 15, 15, 1)" },
                                { label: data.priorities['24'], data: fillData('24', 'prio_results'), backgroundColor: "rgba(107, 107, 107, 1)" },
                                { label: data.priorities['25'], data: fillData('25', 'prio_results'), backgroundColor: "rgba(0, 239, 193, 1)" },
                            ],
                        },
                        options: chartOptions
                    });
                }

                if (maturityChart.length > 0) {
                    new Chart(maturityChart, {
                        ...barChartConfig('Requirements Met', 0, 1, 0.2, true),
                        data: {
                            labels: ["Level 1", "Level 2", "Level 3", "Level 4", "Level 5"],
                            datasets: [
                                { 
                                    label: 'Requirements Met',
                                    data: [
                                        item.progressbar?.level_1.percentage_yes || 0,
                                        item.progressbar?.level_2.percentage_yes || 0,
                                        item.progressbar?.level_3.percentage_yes || 0,
                                        item.progressbar?.level_4.percentage_yes || 0,
                                        item.progressbar?.level_5.percentage_yes || 0,
                                    ],
                                    backgroundColor: "rgb(9, 110, 124)"
                                },
                            ],
                        },
                    });
                }
            })
        }

        const handleExport = (event) => {
            const el = event.currentTarget;
            const chart = document.querySelector(`#${el.getAttribute('data-chart-ref')}`);
            const chartObject = Chart.getChart(`${el.getAttribute('data-chart-ref')}`);

            chartObject.options.plugins.legend.display = true;
            chartObject.update();
     
            el.download = `${chart.getAttribute('aria-label')}.jpeg`
            el.href = chart.toDataURL("image/jpeg", 1.0);

            chartObject.options.plugins.legend.display = false;
            chartObject.update();
        }

        const init = () => {
            $.ajax({
                url: '/submission_jsons',
                type: 'GET',
                success: res => {
                    renderRadarChart(res);
                    renderBarCharts(res);
                }
            });

            $(".chart-export").on('click', handleExport)
        }

        if (isResultChartPage) init();

    });
}(jQuery));